<template>
    <LayoutSub className="company_content">
        <SubSection class="pb-0">
            <h1><span class="c-red">끊임없는 변화</span>를 추구하며 <br /><span class="c-red">선도자</span>가 되도록 매진하는 한국정보통신</h1>
            <div class="vertical_line"></div>
        </SubSection>
        <div class="ceo_container" data-aos="fade-up">
            <div class="inner">
                <div class="photo_area">
                    <img src="@/assets/kicc_ceo.png" alt="">
                </div>
                <div class="text_area">
                    <h2 class="heading_text">
                        안녕하십니까?<br />
                        한국정보통신 홈페이지에 방문해주신 여러분께<br />
                        진심으로 감사의 말씀 드립니다.
                    </h2>
                    <p>
                        한국정보통신은 Total Bridging People & Shop 을 모토로 보다 안전하고 신뢰받는
                        지급결제와 전자금융서비스를 고객 여러분께 제공해 오고 있습니다.<br />
                        <br />
                        그간 기대에 부응하고자 기술혁신과 더불어 다양한 서비스 개발에 주력하여 온 · 오프라인은 물론
                        핀테크 분야에서의 역할도 넓혀가고 있습니다.<br />
                        <br />
                        앞으로도 지급결제의 선도자로서 더욱 앞서가는 기술과 서비스를 발굴,제공함으로써
                        고객과 시장의 발전은 물론 국가발전의 원동력이 되겠습니다.<br />
                    </p>
                    <div class="sign_text">
                        <span>한국정보통신 대표이사</span>
                        <span class="ceo_name">임명수</span>
                    </div>
                </div>
            </div>
        </div>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>
<style lang="scss" scoped></style>
